import { workingDays } from '../config/ref';

export const sortOperationalHour = (times: Array<any>) =>
  workingDays.map((val: any) => {
    const result = times.find((time: any) => time.day === val.day);

    return result;
  });
